import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson19: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson18"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[120%]">
            Technical Analysis
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson20"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[7.5rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">

        <div className="self-stretch flex flex-row items-center justify-center gap-[4.63rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What Is Technical Analysis?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Technical analysis is a trading discipline employed to
                  evaluate investments and identify trading opportunities by
                  analysing statistical trends gathered from trading activity,
                  such as price movement and volume. Unlike fundamental
                  analysis, which attempts to evaluate a security's value based
                  on business results such as sales and earnings, technical
                  analysis focuses on the study of price and volume.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[42.81rem] h-[27.25rem] object-cover"
            alt=""
            src="/i78@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>KEY TAKEAWAYS</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Technical analysis is a trading discipline employed to evaluate
                investments and identify trading opportunities in price trends
                and patterns seen on charts.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                Technical analysts believe past trading activity and price
                changes of a security can be valuable indicators of the
                security's future price movements.
              </span>
            </li>
          </ul>
          <p className="m-0">&nbsp;</p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                Technical analysis may be contrasted with fundamental analysis,
                which focuses on a company's financials rather than historical
                price patterns or stock trends.
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Understanding Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Technical analysis tools are used to scrutinize the ways supply
                and demand for a security will affect changes in price, volume,
                and implied volatility. It operates from the assumption that
                past trading activity and price changes of a security can be
                valuable indicators of the security's future price movements
                when paired with appropriate investing or trading rules.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is often used to generate short-term trading signals from
                various charting tools, but can also help improve the evaluation
                of a security's strength or weakness relative to the broader
                market or one of its sectors. This information helps analysts
                improve their overall valuation estimate.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Using Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Professional analysts often use technical analysis in
                conjunction with other forms of research. Retail traders may
                make decisions based solely on the price charts of a security
                and similar statistics, but practicing equity analysts rarely
                limit their research to fundamental or technical analysis alone.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Technical analysis can be applied to any security with
                historical trading data. This includes stocks, futures,
                commodities, fixed-income, currencies, and other securities. In
                fact, technical analysis is far more prevalent in commodities
                and forex markets where traders focus on short-term price
                movements.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Technical analysis attempts to forecast the price movement of
                virtually any tradable instrument that is generally subject to
                forces of supply and demand, including stocks, bonds, futures,
                and currency pairs. In fact, some view technical analysis as
                simply the study of supply and demand forces as reflected in the
                market price movements of a security.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Technical analysis most commonly applies to price changes, but
                some analysts track numbers other than just price, such as
                trading volume or open interest figures.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Technical Analysis Indicators</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Across the industry, there are hundreds of patterns and signals
                that have been developed by researchers to support technical
                analysis trading. Technical analysts have also developed
                numerous types of trading systems to help them forecast and
                trade on price movements.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some indicators are focused primarily on identifying the current
                market trend, including support and resistance areas, while
                others are focused on determining the strength of a trend and
                the likelihood of its continuation. Commonly used technical
                indicators and charting patterns include trendlines, channels,
                moving averages, and momentum indicators.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In general, technical analysts look at the following broad types
                of indicators:
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Price trends</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Chart patterns</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Volume and momentum indicators</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Oscillators</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Moving averages</span>
              </span>
            </li>
            <li>
              <span>
                <span>Support and resistance levels</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Underlying Assumptions of Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are two primary methods used to analyse securities and
                make investment decisions: fundamental analysis and technical
                analysis. Fundamental analysis involves analysing a company’s
                financial statements to determine the fair value of the
                business, while technical analysis assumes that a security's
                price already reflects all publicly available information and
                instead focuses on the statistical analysis of price movements.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Technical analysis attempts to understand the market sentiment
                behind price trends by looking for patterns and trends rather
                than analysing a security's fundamental attributes.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Markets are efficient with values representing factors that
                  influence a security's price, but
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Even random market price movements appear to move in
                  identifiable patterns and trends that tend to repeat over time
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  The market discounts everything: Technical analysts believe
                  that everything from a company's fundamentals to broad market
                  factors to market psychology is already priced into the stock.
                  This point of view is congruent with the Efficient Markets
                  Hypothesis (EMH) which assumes a similar conclusion about
                  prices. The only thing remaining is the analysis of price
                  movements, which technical analysts view as the product of
                  supply and demand for a particular stock in the market.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Price moves in trends: Technical analysts expect that prices,
                  even in random market movements, will exhibit trends
                  regardless of the time frame being observed. In other words, a
                  stock price is more likely to continue a past trend than move
                  erratically. Most technical trading strategies are based on
                  this assumption.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  History tends to repeat itself: Technical analysts believe
                  that history tends to repeat itself. The repetitive nature of
                  price movements is often attributed to market psychology,
                  which tends to be very predictable based on emotions like fear
                  or excitement. Technical analysis uses chart patterns to
                  analyse these emotions and subsequent market movements to
                  understand trends. While many forms of technical analysis have
                  been used for more than 100 years, they are still believed to
                  be relevant because they illustrate patterns in price
                  movements that often repeat themselves.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Technical Analysis vs. Fundamental Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Fundamental analysis and technical analysis, the major schools
                of thought when it comes to approaching the markets, are at
                opposite ends of the spectrum. Both methods are used for
                researching and forecasting future trends in stock prices, and
                like any investment strategy or philosophy, both have their
                advocates and adversaries.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Fundamental analysis is a method of evaluating securities by
                attempting to measure the intrinsic value of a stock.
                Fundamental analysts study everything from the overall economy
                and industry conditions to the financial condition and
                management of companies. Earnings, expenses, assets, and
                liabilities are all important characteristics to fundamental
                analysts.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Technical analysis differs from fundamental analysis in that the
                stock's price and volume are the only inputs. The core
                assumption is that all known fundamentals are factored into
                price; thus, there is no need to pay close attention to them.
                Technical analysts do not attempt to measure a security's
                intrinsic value, but instead, use stock charts to identify
                patterns and trends that suggest what a stock will do in the
                future.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Limitations of Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Some analysts and academic researchers expect that the EMH
                demonstrates why they shouldn't expect any actionable
                information to be contained in historical price and volume data;
                however, by the same reasoning, neither should business
                fundamentals provide any actionable information. These points of
                view are known as the weak form and semi-strong form of the EMH.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Another criticism of technical analysis is that history does not
                repeat itself exactly, so price pattern study is of dubious
                importance and can be ignored. Prices seem to be better modelled
                by assuming a random walk.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A third criticism of technical analysis is that it works in some
                cases but only because it constitutes a self-fulfilling
                prophecy. For example, many technical traders will place a
                stop-loss order below the 200-day moving average of a certain
                company. If a large number of traders have done so and the stock
                reaches this price, there will be a large number of sell orders,
                which will push the stock down, confirming the movement traders
                anticipated.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Then, other traders will see the price decrease and also sell
                their positions, reinforcing the strength of the trend. This
                short-term selling pressure can be considered self-fulfilling,
                but it will have little bearing on where the asset's price will
                be weeks or months from now.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In sum, if enough people use the same signals, they could cause
                the movement foretold by the signal, but over the long run, this
                sole group of traders cannot drive the price.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Assumptions Do Technical Analysts Make?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Professional technical analysts typically accept three general
                assumptions for the discipline. The first is that, similar to
                the efficient market hypothesis, the market discounts
                everything. Second, they expect that prices, even in random
                market movements, will exhibit trends regardless of the time
                frame being observed. Finally, they believe that history tends
                to repeat itself. The repetitive nature of price movements is
                often attributed to market psychology, which tends to be very
                predictable based on emotions like fear or excitement.
              </span>
            </span>
          </p>
        </div>
        <div className="relative tracking-[0.02em] leading-[2rem] inline-block w-[96.75rem]">
          <p className="m-0">
            <b>
              <span>
                What's the Difference Between Fundamental and Technical
                Analysis?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Fundamental analysis is a method of evaluating securities by
                attempting to measure the intrinsic value of a stock. The core
                assumption of technical analysis, on the other hand, is that all
                known fundamentals are factored into price; thus, there is no
                need to pay close attention to them. Technical analysts do not
                attempt to measure a security's intrinsic value, but instead,
                use stock charts to identify patterns and trends that might
                suggest what the security will do in the future.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Best Ways to Learn Technical Analysis</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                In addition to chart patterns and indicators, technical analysis
                involves the study of wide-ranging topics, such as behavioural
                economics and risk management. The goal behind technical
                analysis is usually to identify trading opportunities and
                capitalize on them using a disciplined, rules-based approach
                that maximizes long-term risk-adjusted returns. In this article,
                we will look at some of the best ways for beginners to learn
                technical analysis without having to risk money in the market.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>KEY TAKEAWAYS</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Technical analysis is the study of charts and patterns, but
                  can also include aspects of behavioural economics and risk
                  management.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Novice traders can turn to books and online courses to learn
                  about technical analysis.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Many online trading courses promise spectacular results and
                  use high-pressure sales tactics, but then fail to deliver the
                  promised results.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Simulated or "paper" trading can help traders see how
                  technical indicators work in live markets.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Practice trading with virtual money</span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Build a Foundation</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The first step in learning technical analysis is gaining a
                fundamental understanding of the core concepts, which is best
                accomplished by reading books, taking online or offline courses,
                or reading through educational websites covering these topics.
                Many of these resources are free, but some educators, workshops,
                or courses charge a fee.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Importantly, many online trading courses promise spectacular
                results and use high-pressure sales tactics, but do not deliver
                the promised results. Novice traders might want to avoid courses
                that boast about unrealistic returns and, instead, seek out
                educators that teach the core fundamentals of technical
                analysis.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Many traders develop their own trading systems and techniques
                over time. After all, companies offering "off the shelf" trading
                systems that yield consistent profits probably wouldn’t be
                selling them if they were indeed profitable (they would keep the
                secrets to themselves).
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300"
        href="/lesson20">
        <div className="w-full">
          <b className="inline-block flex-1 w-full relative text-center max-md:pb-[0.8rem]">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson19;
